import React from "react";
import { connect } from "react-redux";

import { OPPORTUNITY_MODAL } from "components/modals";
import FullPageModal from "../../components/modals/FullPageModal";
import OpportunityForm from "./OpportunityForm";
import OpportunityFilesTable from "./OpportunityFilesTable";
import ModalArrows from "../../components/modals/ModalArrows";
import { activeOpportunitySelector, activeTabSelector, opportunitiesSelector } from "../../reducers";
import { clearSelectedOpportunity, parseActiveSectionToEndpoint, selectOpportunity } from "../../actions";
import { findPreviousAndNext } from "../../utils";

const OpportunityModal = ({ ...props }) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <FullPageModal modalType={OPPORTUNITY_MODAL}>
      <ModalArrows
        onclick={entry => {
          props.clearSelectedOpportunity();
          props.selectOpportunity(entry.id);
        }}
        nextEntry={props.next}
        prevEntry={props.previous}
        setLoading={setLoading}
        canNextPage={props.canNextPage}
        canPreviousPage={props.canPreviousPage}
        endpoint={props.endpoint}
        type={"Opportunity"}
      />
      <OpportunityForm />
      <OpportunityFilesTable />
    </FullPageModal>
  );
};

const mapStateToProps = state => {
  const tab = activeTabSelector(state);
  const endpoint = parseActiveSectionToEndpoint(tab);
  let pageCount = 0;
  let currentPage = 0;

  let opportunities = opportunitiesSelector(state);
  let activeOpportunity = activeOpportunitySelector(state);
  const { previous, next } = findPreviousAndNext(opportunities, activeOpportunity);

  return {
    opportunities,
    canPreviousPage: currentPage > 1,
    canNextPage: currentPage < pageCount,
    endpoint,
    previous,
    next,
  };
};

export default connect(mapStateToProps, {
  selectOpportunity,
  clearSelectedOpportunity,
})(OpportunityModal);
